export enum StoreType{
    Memory = 1,
    Persistent = 2
}
